var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('v-container',[_c('div',{staticClass:"text-xs-center mt-5"},[_c('div',{staticClass:"display-2"},[_vm._v("404")]),_c('div',{staticClass:"Headline"},[_vm._v("Not found this page")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }